import { useMediaQuery } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { theme } from '../../../theme'

export const HeaderLogo = () => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const navigate = useNavigate()

    return (
        <a
            onClick={() => navigate(`/`)}
            style={{
                cursor: 'pointer',
                marginRight: 'auto',
                height: isMobile ? '28px' : '40px',
                width: isMobile ? '28px' : '40px',
            }}>
            <img src={isMobile ? '/mobile-logo.svg' : '/logo.svg'} />
        </a>
    )
}
